import { configureStore } from "@reduxjs/toolkit";
import CounterSlice from "./counterSlice";
import persistentSlice from "./persistentSlice";
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import historySlice from "./historySlice";
import lensSlice from "./lensSlice";
const persistConfig = {
    key: "root",
    version: 1,
    storage,
};

const persistedReducer = persistReducer(persistConfig, persistentSlice);
const store = configureStore({
    reducer: {
        counter: CounterSlice,
        history: historySlice,
        persistent: persistedReducer,
        lens: lensSlice
    },

    middleware: (getDefaultMiddleware) =>

        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});
const persistor = persistStore(store);

export   {store, persistor};

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch